import axios from "axios";

class LuckyDayRepository {
  findExpectNumbers(callback) {
    axios.get("/v1/api/lucky-day/numbers-by-count")
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  findNumberCount(params = {}, callback) {
    axios.get("/v1/api/luckyday/numbers")
      .then((res => {
        if (res.status === 200)
          callback && callback(res.data);
      }));
  }
}

export { LuckyDayRepository };
